// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1LHZ3","file":"styles_file__3Cy1y"};